"use client";

import React from "react";
import styled from "styled-components";
import { Text } from "@lmn/design-system";
import TextButton from "../TextButton/TextButton";

interface ReviewsCountProps {
  count: number;
  isGood?: boolean;
  label?: string;
  onClick?: () => void;
}

const StyledText = styled(Text)<{ $isGood?: boolean }>(
  ({ theme, $isGood }) => ({
    color: $isGood
      ? theme.kallisto.color.text.static.textSuccess
      : theme.kallisto.color.text.static.textSecondary,
  })
);

const ReviewsCount: React.FC<ReviewsCountProps> = ({
  count,
  isGood = false,
  label = "Bewertungen",
  onClick,
}) => {
  return (
    <>
      {onClick ? (
        <TextButton onClick={onClick} data-testid="reviews-count-button">
          {count} {label}
        </TextButton>
      ) : (
        <StyledText variant="BodySmall" $isGood={isGood} onClick={onClick}>
          {count} {label}
        </StyledText>
      )}
    </>
  );
};

export default ReviewsCount;
